import React, { useState } from 'react';
import { Button } from './ui/button';
import { Flame, X } from 'lucide-react';
import { i18n } from '../utils/i18n';

interface EventEndedPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export function EventEndedPopup({ isOpen, onClose }: EventEndedPopupProps) {
  const [isClosing, setIsClosing] = useState(false);

  if (!isOpen) return null;

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 200);
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div
        className={`bg-white rounded-2xl p-8 w-full max-w-md shadow-2xl transform transition-all duration-300 ${
          isClosing ? 'scale-95 opacity-0' : 'scale-100 opacity-100'
        }`}
      >
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center">
              <Flame className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-800">{i18n.t('event1EndedTitle')}</h2>
            </div>
          </div>
          <button
            onClick={handleClose}
            className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
          >
            <X className="w-4 h-4 text-gray-600" />
          </button>
        </div>

        <div className="space-y-6">
          <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6">
            <p className="text-base text-gray-800 leading-relaxed text-center whitespace-pre-line">
              {i18n.t('event1EndedBody')}
            </p>
          </div>

          <Button
            onClick={handleClose}
            className="w-full h-12 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-semibold rounded-xl shadow-lg text-base"
          >
            {i18n.t('confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
}
